<script setup>
defineProps({
  data: Object
})
const { altFallback } = usePageAltFallback();
const getCardImageAlt = (card) =>
  resolveMediaAlt(card?.cardImage, card?.cardTitle, altFallback.value, 'Image');
</script>

<template>
  <div class="block card-image-content">
    <div class="container">
      <div class="row justify-content-center">
        <div :class="['col-12', data.card.length <=3 ? 'col-sm-4': 'col-sm-3']" v-for="card in data.card" :key="card.id || card.cardTitle">
          <div class="card-image-content-container">
            <NuxtImg
              :src="card?.cardImage?.url"
              :alt="getCardImageAlt(card)"
              loading="lazy"
              decoding="async"
              format="webp"
              class="card-image"
            />
            <article class="card-content" v-html="card.cardDescription"></article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .card-image-content {

    // Selecting all card containers as they are columns
    [class*=" col-"]{
      margin-bottom: 10px;
      @include media-breakpoint-up(lg) {
        margin-bottom: 0;
      }
    }
    .card-image-content-container {
      height: 100%;
      overflow: hidden;
      border-radius: 24px;
      border: solid 1px $color-light-gray;
      .card-image {
        max-width: 100%;
        margin: 0 auto;
        display: block;
      }
      .card-content {
        display: block;
        margin-top: 20px;
        padding: 0 20px;
        font-size: $font-size-base;

        .btn {
          width: 100%;
        }
      }
    }
  }
</style>